import { SWRFetcher } from '@commenda/utils';
import { FileFolder } from '@prisma/client';
import useSWR, { KeyedMutator } from 'swr';

export default function useFileFolders(corporationId: number, token: string) {
  const requestBaseURI = corporationId
    ? `fileFolder/byCorporationId/${corporationId}`
    : null;

  const {
    data,
    error,
    mutate,
  }: {
    data?: FileFolder[];
    error?: unknown;
    mutate: KeyedMutator<FileFolder[]>;
  } = useSWR(
    requestBaseURI,
    SWRFetcher(
      {
        method: 'GET',
      },
      token
    )
  );

  return {
    data,
    error,
    mutate,
  };
}
